import { createFileRoute } from "@tanstack/react-router";
import { CreditCard, Sparkles, QrCode } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import { alternateLinkList } from "@/lib/i18n/locale";
import heroImg from "@/assets/hero-card.webp";

export const Route = createFileRoute("/el/platform/identity-and-sharing")({
  head: () => ({
    meta: [
      { title: "Ταυτότητα και κοινοποίηση — banana.cards" },
      { name: "description", content: "Ψηφιακές επαγγελματικές κάρτες, premium προϊόντα NFC και κάθε κανάλι κοινοποίησης — QR, Wallet, σύνδεσμοι, υπογραφές email." },
      { property: "og:title", content: "Ταυτότητα και κοινοποίηση — banana.cards" },
      { property: "og:description", content: "Ψηφιακές επαγγελματικές κάρτες, premium προϊόντα NFC και κάθε κανάλι κοινοποίησης — QR, Wallet, σύνδεσμοι, υπογραφές email." },
      { property: "og:image", content: heroImg },
      { property: "og:locale", content: "el_GR" },
    ],
    links: alternateLinkList("/platform/identity-and-sharing", "el"),
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="Ταυτότητα και κοινοποίηση"
      title="Μία ταυτότητα,"
      italic="κάθε κανάλι."
      description="Μια όμορφη ψηφιακή επαγγελματική κάρτα, ένα premium προϊόν NFC για κοινοποίηση με άγγιγμα και όλα τα εργαλεία δικτύωσης που μετατρέπουν κάθε άγγιγμα σε συζήτηση."
      heroImage={heroImg}
      features={[
        { title: "Ψηφιακές επαγγελματικές κάρτες", desc: "Όμορφα, προσαρμόσιμα προφίλ για κάθε μέλος της ομάδας — με συνδέσμους, πολυμέσα και κουμπιά δράσης.", href: "/el/platform/cards", icon: CreditCard, bullets: ["Επεξεργασία με μεταφορά και απόθεση", "Προσαρμοσμένη εταιρική ταυτότητα και θέματα", "Πολλές κάρτες ανά χρήστη"] },
        { title: "Κάρτες NFC", desc: "Premium προϊόντα NFC από μέταλλο, μπαμπού, PVC και χρυσό 24kt — ανθεκτικά, για κοινοποίηση με ένα άγγιγμα.", href: "/el/platform/nfc", icon: Sparkles, bullets: ["6 premium υλικά", "Δικό σας εικαστικό", "Επαναπρογραμματισμός οποτεδήποτε"] },
        { title: "Κοινοποίηση και δικτύωση", desc: "QR, Apple Wallet και Google Wallet, υπογραφές email, φόρμες ανταλλαγής και προστασία PIN — κάθε κανάλι κοινοποίησης στη διάθεσή σας.", href: "/el/platform/sharing", icon: QrCode, bullets: ["6 εργαλεία δικτύωσης", "Παρακολούθηση και αναλυτικά στοιχεία", "Apple Wallet και Google Wallet"] },
      ]}
      outro={{ title: "Η ταυτότητά σας, ", italic: "παντού.", description: "Ένα προφίλ, κάθε συσκευή, κάθε κανάλι — κοινοποίηση σε δευτερόλεπτα." }}
    />
  );
}
